import { HTMLAttributes } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { CallInsightPanelLoader } from './call-insight-panel-loader';

export const CallInsightContent = ({
  children,
  isLoading,
}: HTMLAttributes<HTMLDivElement> & { isLoading: boolean }) => {
  return <div css={styles.content}>{!isLoading ? children : <CallInsightPanelLoader />}</div>;
};

const LeadContent = ({ children }: HTMLAttributes<HTMLDivElement>) => {
  return <div css={styles.leadContent}>{children}</div>;
};

const BodyContent = ({ children }: HTMLAttributes<HTMLDivElement>) => {
  return <div css={styles.bodyContent}>{children}</div>;
};

const FooterContent = ({ children }: HTMLAttributes<HTMLDivElement>) => {
  return <div css={styles.footerContent}>{children}</div>;
};

CallInsightContent.Lead = LeadContent;
CallInsightContent.Body = BodyContent;
CallInsightContent.Footer = FooterContent;

const styles = {
  content: css`
    display: flex;
    flex-direction: column;
    padding: ${theme.spacing(3)};
    gap: ${theme.spacing(2)};
    height: 100%;
    overflow: hidden auto;
  `,
  leadContent: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `,
  bodyContent: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `,
  footerContent: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
    margin-top: auto;
  `,
};
